<template>
  <div class="tesco-lotus-div">
    <b-img class="img-counter" src="/images/logo-Tesco-Lotus.png"  :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"/>
    <div class="text-description">{{$t('payment.methods.payOverCounter.description')}}<br>{{$t('payment.methods.payOverCounter.charge')}}</div>
    <div class="wrap-btn-payment">
      <b-spinner v-if="loading" label="Loading..." variant="'primary'"></b-spinner>
      <b-button v-else class="btn-payment" id="processPayment" @click="processPayment">{{ formattedAmount }}</b-button>

      <b-img src="/images/secured.png" class="secured-image" :alt="$t('advertiseWithUsAlt',{ site_name: $root.siteTitle})"/>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import * as actionType from "../../../../controllers/ActionTypes";
export default {
  name: "counterBill",
  props: {
    formattedAmount: {
      type: String,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
    changeLoading: {
      type: Function,
      required: true
    },
    previousPendingPaymentId: {
      required: false,
      default: null
    }
  },
  data() {
    return {
      loading: false
    };
  },
  watch: {
    loading: function() {
      this.changeLoading(this.loading);
    }
  },
  methods: {
    ...mapActions("PaymentController", [actionType.PAY]),
    processPayment() {
      this.loading = true;
      var vm = this;
      vm.PAY({
        user_payment_id: vm.orderId
      })
        .then(function(response) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: { id: vm.orderId, previousPendingPaymentId: vm.previousPendingPaymentId }
          });
        })
        .catch(function(error) {
          vm.$router.push({
            name: "PaymentSuccess",
            params: { id: vm.orderId, previousPendingPaymentId: vm.previousPendingPaymentId }
          });
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tesco-lotus-div{
   flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center space-around;
  align-items: center;
  .img-counter{
    width:250px;
  }
  .wrap-btn-payment {
    margin-top: 20px;
    width: 100%;
    flex-direction: column;
    box-sizing: border-box;
    display: flex;
    place-content: center center;
    align-items: center;
    .btn-payment {
      width: 100%;
      border-radius: 20px;
    }
  }
  .secured-image {
    width: 150px;
    margin-top:20px;
  }
}
.counterbill {
  background: #ffffff 0% 0% no-repeat padding-box;
  margin: 50px;
}
.logo {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
}
​ .logoimg {
  width: 300px;
  height: 234px;
}
.rightcontent {
  font-size: 65px;
  width: 455px;
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  text-align: right;
  padding: 20px 0;
}
​ .toptext {
  color: #444444;
}
.secondrow {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
  margin-top: 12px;
}
​ .address {
  width: 400px;
  font-size: 22px;
}
.boldaddress {
  color: #444444;
  font-weight: bold;
}
.secondrightcontent {
  width: 450px;
  font-size: 20px;
}
​ .secondrightcontentdiv {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
}
.thirdrow {
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  margin-top: 65px;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
}
.fourthrow {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
  margin-bottom: 20px;
}
.fourthrighttext {
  width: 240px;
  color: #444444;
  font-weight: bold;
  font-size: 24px;
}
.fourthlefttext {
  color: #444444;
  margin-left: 20px;
  font-size: 24px;
  word-break: break-word;
}
​ .package {
  border-bottom: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  margin-top: 65px;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
}
​ .firstlable {
  width: 200px;
}
.secondlable {
  width: 300px;
}
.package-div {
  margin-top: 20px;
  font-size: 24px;
  padding-bottom: 20px;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
}
​ .package-div-firstlable {
  width: 200px;
  padding-left: 30px;
}
​ .package-div-secondlable {
  width: 300px;
  text-align: left;
}
​ .total {
  border-top: 3px solid var(--projectPrimaryColor) !important;
  color: #444444;
  font-weight: bold;
  font-size: 32px;
  padding-bottom: 20px;
  ​margin-bottom: 50px;
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
}
.total-div {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: flex-start;
  width: 100%;
  padding-top: 20px;
}
​ .total-div-label {
  padding-left: 30px;
}
.total-div-price {
  width: 300px;
  text-align: left;
}
​ .total-amount {
  height: 100px;
  background: var(--projectPrimaryColor) 0% 0% no-repeat padding-box !important ;
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
  font-size: 32px;
  color: white;
}
​ .total-amount-label {
  padding-left: 30px;
}
.total-amount-price {
  width: 300px;
  text-align: left;
}
​ .footer-logo {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: center space-between;
  align-items: center;
  margin: 20px;
}
​ .tesco-logo {
  flex-direction: column;
  box-sizing: border-box;
  display: flex;
  place-content: center;
  align-items: center;
  font-size: 32px;
}
​ .tescoimage {
  width: 200px;
  margin-top: 20px;
}
.qrimage {
  width: 500px;
  height: 200px;
}
​ .footer {
  flex-direction: row;
  box-sizing: border-box;
  display: flex;
  place-content: flex-start;
  align-items: flex-start;
  border-top: 3px solid var(--projectPrimaryColor) !important;
  padding-top: 20px;
}
​ .footer-text {
  font-size: 24px;
  margin-right: 50px;
}
</style>